import { createRouter, createWebHistory } from "vue-router";
import silentLogin from "@/components/silent_login/Login.vue";
import ssoLogin from "@/components/sso/Login.vue";
import invoicePDF from "@/components/invoice/invoice.vue";
import appointmentDetail from "@/views/appointment/AppointmentDetail.vue";
import quoteDetail from "@/views/quote/QuoteDetail.vue";
import editQuote from "@/views/quote/QuoteEdit.vue";
import notfound from "@/views/NotFound.vue";
import login from "../views/nest_views/login.vue";
import dashboard from "../views/dashboard/dashboard.vue";
import jobdetail from "../views/nest_views/job-detail.vue";
import selectunit from "../views/nest_views/select-unit.vue";   
import jobmembers from "../views/nest_views/job-members.vue";
import evaluation from "../views/nest_views/evaluation.vue";
import evaluationPreCheck from "../views/nest_views/evaluation-pre-check.vue";
import initialCheck from "../views/nest_views/initial-check.vue";
import outdoorequipment from "../views/nest_views/outdoor-equipment.vue";
import equipment from "../views/nest_views/indoor-outdoor-equipment.vue";
import indoorequipment from "../views/nest_views/indoor-equipment.vue";
import summary from "../views/nest_views/summary.vue";
import finalEvaluation from "../views/nest_views/final-evaluation.vue";
import summaryDetail from "../views/nest_views/summary-detail.vue";
import editSummary from "../views/nest_views/edit-summary.vue";
import success from "../views/nest_views/nest-success.vue";
import failure from "../views/nest_views/nest-success.vue";
import plan from "../views/protection-plan/plan.vue";
import salesHistory from "../views/protection-plan/sales-history.vue";
import commisionAmount from "../views/protection-plan/commision-amount.vue";
import appointmentListing from "../views/work-order/appointments/appointment.vue";
import appointmentsDetail from "../views/work-order/appointments/appointmentsDetail.vue";
import serviceRepairListing from "../views/work-order/ServiceAndRepair.vue";
import replacementQuote from "../views/work-order/replacementQuote.vue";
import rqDetail from "../views/replacement-quote/RqDetail.vue";
import rqDataSheet from "../views/replacement-quote/RqDataSheet.vue";
import rqSystemSummary from "../views/replacement-quote/RqSystemSummary.vue";
import rqSummaryEdit from "../views/replacement-quote/RqSummaryEdit.vue";
import universalQuotes from "../views/work-order/universalQuotes.vue";
import register from "../views/nest_views/register.vue";
import verification from "../views/nest_views/verification.vue";
import forgetPassword from "../views/nest_views/reset-password.vue"
import search from "../views/globalSearch/search.vue";
import protectionPlans from "../views/protection-plan/index.vue";
import { faL } from "@fortawesome/free-solid-svg-icons";
import lastEvaluation from "../views/nest_views/last-evaluation.vue";
import viewEvaluation from "../views/nest_views/view-evaluation.vue";
import checkoutDetail from "@/views/checkout/index.vue";
import checkoutRedirections from "@/views/checkout/redirections.vue";
import { constants } from "../helpers/helperFunction";
import { disableScroll, enableScroll } from "../helpers/scrollHelper";
import { recordHistoryPosition } from "../helpers/historyPositions";
import { recordCrumbNav } from "../helpers/crumbTrail";
import { releaseStaleScrollLock } from "../helpers/scrollHelper";
import { LIST_BY_ROUTE } from "../helpers/listFilters";
import paymentLinkCheckoutRedirections from "@/views/checkout/paymentLinkRedirections.vue";
import omegaListing from "../views/omega/affiliate/affiliateListing.vue";
import partnerList from "../views/protection-plan-partner/bundle-list.vue";
import partnerCheckout from "../views/protection-plan-partner/partner-checkout/chekout.vue";
import thankyou from "../views/protection-plan-partner/partner-checkout/thankyou.vue";
import commonParts from "../views/nest_views/commonParts.vue";
import productList from "../views/protection-plan-partner/products.vue";
import termsAndConditions from "../views/protection-plan-partner/partner-checkout/terms-and-condtion.vue";
import dashboardHappyHome from "../views/myHappyHome/dashboard.vue";
import jobInvoice from "../views/nest_views/job-invoice.vue";
import messagesInbox from "../views/messages/Inbox.vue";
import systemDesigner from "../views/system-designer/SystemDesigner.vue";
import adminUtilities from "../views/admin-utilities/AdminUtilities.vue";

const routes = [
    {
        path: "/login",
        name: "login",
        component: login,
        meta: {
            layout: 'auth'
        }
    },
    {
        path: "/register",
        name: "register",
        component: register,
        meta: {
            layout: 'auth'
        }
    },
    {
        path: "/verification",
        name: "verification",
        component: verification,
        meta: {
            layout: 'auth'
        }
    },
    {
        path: "/forgetPassword",
        name: "forgetPassword",
        component: forgetPassword,
        meta: {
            layout: 'auth'
        }
    },
    {
        path: "/",
        name: "silentLogin",
        component: silentLogin,
        meta: {
            layout: 'auth'
        }
    },
    {
        path: "/sso",
        name: "ssoLogin",
        component: ssoLogin,
        meta: {
            layout: 'auth'
        }
    },
    {
        path: "/appointment/detail/:id",
        name: "AppointmentDetail",
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.APPOINTMENT_TITLE,
            layout: 'main',
            allowSilentLogin: true // silent login / SSO deep-link target
        },
        component: appointmentDetail,
    },
    {
        path: "/quote/detail/:id",
        name: "QuoteDetail",
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.UQ_TITLE,
            layout: 'main',
            allowSilentLogin: true // silent login / SSO deep-link target

        },
        component: quoteDetail,
    },
    {
        path: "/quote/edit/:id",
        name: "QuoteEdit",
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.UQ_TITLE,
            layout: 'main',
            allowSilentLogin: true // silent login / SSO deep-link target
        },
        component: editQuote,
    },
    {
        path: "/not-found",
        name: "NotFound",
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'auth'
        },
        component: notfound,
    },
    // nest_view router

    {
        path: "/dashboard",
        name: "dashboard",
        component: dashboard,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    // ADO-7600 G-25 side menu items (role-filtered by side-menu/web, like the Android dashboard tiles)
    {
        path: "/system-designer",
        name: "systemDesigner",
        component: systemDesigner,
        meta: {
            requiresAuth: true,
            layout: 'main'
        },
    },
    {
        path: "/admin-utilities",
        name: "adminUtilities",
        component: adminUtilities,
        meta: {
            requiresAuth: true,
            layout: 'main'
        },
    },
    {
        path: "/job/detail/:id",
        name: "job-detail",
        component: jobdetail,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.SAR_TITLE,
            // Figma "Service & Repair - Details" uses the main layout (sidebar + header)
            layout: 'main',
            // mobile/SSO users (isSilentLogin) come back here from the evaluation flow
            allowSilentLogin: true
        },
    },
    {
        // Figma "Service & Repair - Details - Members & Contacts": Consumer Details → View Members
        path: "/job/detail/:id/members",
        name: "job-members",
        component: jobmembers,
        meta: {
            requiresAuth: true,
            title: constants.SAR_TITLE,
            layout: 'main',
            allowSilentLogin: true
        },
    },
    {
        // same Members page from Appointment Details → View Members (user, 19 Oct: page, not a modal)
        path: "/appointment/detail/:id/members",
        name: "appointment-members",
        component: jobmembers,
        meta: {
            requiresAuth: true,
            title: constants.APPOINTMENT_TITLE,
            layout: 'main',
            allowSilentLogin: true
        },
    },
    {
        // same Members page from Universal Quote Details → View Members
        path: "/quote/detail/:id/members",
        name: "quote-members",
        component: jobmembers,
        meta: {
            requiresAuth: true,
            title: constants.UQ_TITLE,
            layout: 'main',
            allowSilentLogin: true
        },
    },
    {
        path: "/select/unit/:id",
        name: "select-unit",
        component: selectunit,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.SAR_TITLE,
            // Figma "Service & Repair - Select a Unit": main layout; mobile "diagnosis" link lands here
            layout: 'main',
            allowSilentLogin: true
        },
    },
    {
        path: "/evaluation",
        name: "evaluation",
        component: evaluation,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.SAR_TITLE,
            layout: 'auth'
        },
    },
    {
        path: "/evaluation-pre-check",
        name: "evaluation-pre-check",
        component: evaluationPreCheck,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.SAR_TITLE,
            layout: 'auth'
        },
    },
    {
        path: "/initial-check/:id",
        name: "initial-check",
        component: initialCheck,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.SAR_TITLE,
            layout: 'main', // Figma S&R evaluation screens
            allowSilentLogin: true
        },
    },
    {
        path: "/outdoor-equipment/:id",
        name: "outdoor-equipment",
        component: outdoorequipment,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.SAR_TITLE,
            layout: 'auth'
        },
    },
    {
        path: "/equipment/:id",
        name: "equipment",
        component: equipment,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.SAR_TITLE,
            layout: 'main', // Figma S&R evaluation screens
            allowSilentLogin: true
        },
    },
    {
        path: "/indoor-equipment",
        name: "indoor-equipment",
        component: indoorequipment,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.SAR_TITLE,
            layout: 'auth'
        },
    },
    {
        path: "/summary/:id",
        name: "summary",
        component: summary,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.SAR_TITLE,
            layout: 'main', // Figma S&R evaluation screens
            allowSilentLogin: true
        },
    },
    {
        path: "/final-evaluation/:id",
        name: "final-evaluation",
        component: finalEvaluation,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.SAR_TITLE,
            layout: 'main', // Figma S&R evaluation screens
            allowSilentLogin: true
        },
    },
    {
        path: "/summary-detail/:id",
        name: "summary-detail",
        component: summaryDetail,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.SAR_TITLE,
            layout: 'main', // Figma S&R evaluation screens
            allowSilentLogin: true
        },
    },
    {
        path: "/edit-summary/:id",
        name: "edit-summary",
        component: editSummary,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.SAR_TITLE,
            layout: 'main', // Figma S&R evaluation screens
            allowSilentLogin: true
        },
    }, {
        path: "/success",
        name: "success",
        component: success,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'auth'
        },
    },
    {
        path: "/failure",
        name: "failure",
        component: failure,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'auth'
        },
    },
    // protection plan routes
    {
        path: "/plans/nrg/:id",
        name: "protections-plans",
        component: protectionPlans,
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            layout: 'main'
        },
    },

    // {
    //     path: "/protection-plan/nrg/bundle-list",
    //     name: "hvac-plan",
    //     component: bundleList,
    //     meta: {
    //         requiresAuth: true, // Add meta field to indicate protected route
    //         layout: 'main'
    //     },
    // },



    {
        path: "/protection-plan/nrg/plan",
        name: "plan",
        component: plan,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        path: "/protection-plan/sales-history",
        name: "salesHistory",
        component: salesHistory,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        path: "/protection-plan/commissions",
        name: "commisionAmount",
        component: commisionAmount,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },



    {
        path: "/protection-plan/:partnerSlug/products",
        name: "products",
        component: productList,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },


    {
        path: "/protection-plan/:partnerSlug/:routeSlug",
        name: "partner",
        component: partnerList,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },

    {
        path: "/global-search",
        name: "globalSearch",
        component: search,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        path: "/checkout/invoice/:id",
        name: "checkoutDetail",
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.CHECKOUT_TITLE,
            layout: 'main', // Figma P1–P14 "Payment Method" inside the main layout
            allowSilentLogin: true // SSO / mobile app and payment links still open it
        },
        component: checkoutDetail,
    },
    // {
    //     path: "/protection-plan/nrg/bundle-list",
    //     name: "bundleList",
    //     component: bundleList,
    //     meta: {
    //         requiresAuth: true, // Add meta field to indicate protected route
    //         layout: 'main'
    //     },
    // },
    {
        // Figma S&R View Evaluation / Approve Quote (?tab=approve)
        path: "/job/evaluation/:id",
        name: "view-evaluation",
        component: viewEvaluation,
        meta: {
            requiresAuth: true,
            title: constants.SAR_TITLE,
            layout: 'main',
            allowSilentLogin: true
        },
    },
    {
        path: "/last-evaluation/:id",
        name: "last-evaluation",
        component: lastEvaluation,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.SAR_TITLE,
            layout: 'main', // Figma S&R evaluation screens
            allowSilentLogin: true
        },
    },
    {
        path: "/checkout-success",
        name: "checkoutSuccess",
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'auth'
        },
        component: checkoutRedirections,
    },
    {
        path: "/checkout-failed",
        name: "checkoutFailed",
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'auth'
        },
        component: checkoutRedirections,
    },
    {
        path: "/checkout/:id/success",
        name: "paymentLinkCheckoutSuccess",
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'auth'
        },
        component: paymentLinkCheckoutRedirections,
    },
    {
        path: "/checkout/:id/fail",
        name: "paymentLinkCheckoutFailed",
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'auth'
        },
        component: paymentLinkCheckoutRedirections,
    },

    // ------------------------
    // omega 
    {
        path: "/affiliates",
        name: "omegaListing",
        component: omegaListing,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'main'
        },
    },

    // ------------------------
    // partner-checkout 
    {
        path: "/partner/checkout",
        name: "partnerCheckout",
        component: partnerCheckout,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'main'
        },
    },
    // ------------------------
    // partner-checkout 
    {
        path: "/thankyou",
        name: "thankyou",
        component: thankyou,
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'default'
        },
    },
    // ------------------------

    // ------------------------
    // Terms and Conditon
    {
        path: "/terms-and-conditions",
        name: "termsAndConditions",
        component: termsAndConditions,
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'default'
        },
    }, 
    // ------------------------
    {
        path: "/happyhome/dashboard",
        name: "dashboardHappyHome",
        component: dashboardHappyHome,
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            layout: 'main' 
            // layout: 'default'
        },
    }, 
    {
        path: "/price-list",
        name: "commonParts",
        component: commonParts,
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'default'
        },
    },

    {
        path: "/work-order/appointment",
        name: "appointment",
        component: appointmentListing,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        // in-app chat inbox (Android InboxFragment)
        path: "/messages",
        name: "messages",
        component: messagesInbox,
        meta: {
            requiresAuth: true,
            layout: 'main',
            allowSilentLogin: false
        },
    },
    {
        path: "/work-order/service-and-repair",
        name: "serviceRepair",
        component: serviceRepairListing,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        // Replacement Quote (order) detail — no Figma; Android technician app parity
        path: "/replacement-quote/detail/:id",
        name: "rq-detail",
        component: rqDetail,
        meta: {
            requiresAuth: true,
            title: constants.SAR_TITLE,
            layout: 'main',
            allowSilentLogin: true // silent login / SSO deep-link target
        },
    },
    {
        // RQ Data Sheet (Android FragmentDataSheet1…4) — opened from the RQ detail "Data Sheet" action
        path: "/replacement-quote/data-sheet/:id",
        name: "rq-data-sheet",
        component: rqDataSheet,
        meta: {
            requiresAuth: true,
            title: constants.SAR_TITLE,
            layout: 'main',
            allowSilentLogin: true // reached from the RQ detail, which is a silent login / SSO target
        },
    },
    {
        // Create Replacement Quote (port of the Laravel single pager): 6 steps inside one shell, state in the query
        path: "/rq",
        component: () => import("../views/rqCreate/RqShell.vue"),
        meta: { requiresAuth: true, layout: 'main' },
        children: [
            { path: "consumer", name: "rq-create-consumer", component: () => import("../views/rqCreate/ConsumerStep.vue"), meta: { requiresAuth: true, layout: 'main', step: 1 } },
            { path: "system-config", name: "rq-create-config", component: () => import("../views/rqCreate/SystemConfigStep.vue"), meta: { requiresAuth: true, layout: 'main', hideSideMenu: true, step: 2 } },
            { path: "select-system", name: "rq-create-select", component: () => import("../views/rqCreate/SelectSystemStep.vue"), meta: { requiresAuth: true, layout: 'main', hideSideMenu: true, step: 3 } },
            { path: "system-detail", name: "rq-create-detail", component: () => import("../views/rqCreate/SystemDetailStep.vue"), meta: { requiresAuth: true, layout: 'main', hideSideMenu: true, step: 4 } },
            { path: "add-ons", name: "rq-create-addons", component: () => import("../views/rqCreate/AddonsStep.vue"), meta: { requiresAuth: true, layout: 'main', hideSideMenu: true, step: 5 } },
            { path: "cart", name: "rq-create-cart", component: () => import("../views/rqCreate/CartStep.vue"), meta: { requiresAuth: true, layout: 'main', hideSideMenu: true, step: 6 } },
            { path: "no-product", name: "rq-create-no-product", component: () => import("../views/rqCreate/NoProduct.vue"), meta: { requiresAuth: true, layout: 'main', hideSideMenu: true } },
        ],
    },
    {    
        // RQ System Summary (ADO-8932 summary in the app theme) — opened from the RQ detail "System Summary" action
        path: "/replacement-quote/summary/:id",
        name: "rq-summary",
        component: rqSystemSummary,
        meta: {
            requiresAuth: true,
            title: constants.SAR_TITLE,
            layout: 'main',
            allowSilentLogin: true // reached from the RQ detail, which is a silent login / SSO target
        },
    },
    {
        // RQ Edit Summary (hosted quotebuilder/edit form in the app theme) — opened from the System Summary page
        path: "/replacement-quote/summary/:id/edit",
        name: "rq-summary-edit",
        component: rqSummaryEdit,
        meta: {
            requiresAuth: true,
            title: constants.SAR_TITLE,
            layout: 'main',
            allowSilentLogin: true // reached from the RQ detail, which is a silent login / SSO target
        },
    },
    {
        path: "/work-order/replacement-quote",
        name: "replacementQuote",
        component: replacementQuote,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        path: "/work-order/universal-quotes",
        name: "universalQuotes",
        component: universalQuotes,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    // {
    //     path: "/work-order/appointment/detail/:id",
    //     name: "appointmentsDetail",
    //     component: appointmentsDetail,
    //     meta: {
    //         requiresAuth: true, // Add meta field to indicate protected route
    //         layout: 'main'
    //     },
    // },
    
    {
        path: "/job/invoice/:id",
        name: "job-invoice",
        component: jobInvoice,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.SAR_TITLE,
            layout: 'main', // Figma S&R evaluation screens
            allowSilentLogin: true
        },
    },
    {
        path: "/invoice/:id",
        name: "invoicePDF",
        component: invoicePDF,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.SAR_TITLE,
            layout: 'auth'
        },
    },
    // ------------------------

    // {
    //   path: '/:pathMatch(.*)*',
    //   name: 'NotFound',
    //   meta: {
    //     requiresAuth: true // Add meta field to indicate protected route
    //   },
    //   component: notfound
    // },
    // {
    //   path: '/about',
    //   name: 'About',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    // },
    // {
    //   path: '/products',
    //   name: 'Products',
    //   component: () => import('../views/products/ProductList.vue')
    // },
    // {
    //   path: '/products/create',
    //   name: 'Product Create',
    //   component: () => import('../views/products/ProductCreate.vue')
    // },
    // {
    //   path: '/products/edit/:id',
    //   name: 'ProductEdit',
    //   component: () => import('../views/products/ProductEdit.vue')
    // }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    // pages open at the top; Back/Forward to a list (work orders, search) returns to the same rows;
    // query-only changes on the same page (list paging / filters / tabs) don't move. instant: html scrolls smooth.
    scrollBehavior(to, from, savedPosition) {
        // Back/Forward to a list: it refetches its rows, so wait (max 3s) until it is tall enough, else the spot gets
        // clamped. Flow pages (Select Unit, Equipment …) open at the top even on Back.
        if (savedPosition && (to.name in LIST_BY_ROUTE || to.name === "globalSearch")) {
            return new Promise((resolve) => {
                const start = Date.now();
                const tick = () => {
                    const max = document.documentElement.scrollHeight - window.innerHeight;
                    if (max >= savedPosition.top || Date.now() - start > 3000) resolve({ ...savedPosition, behavior: "instant" });
                    else setTimeout(tick, 100);
                };
                tick();
            });
        }
        if (to.path === from.path) return false;
        return { top: 0, left: 0, behavior: "instant" };
    },
});

router.beforeResolve((to, from, next) => {
    if (to.name) {

    }
    next();
});

router.afterEach((to) => {
    recordHistoryPosition(to.path);
    recordCrumbNav();
    releaseStaleScrollLock();
});




router.beforeEach((to, from, next) => {

    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
        backdrop.remove();
    }
    // $(".modal-backdrop").remove();
    document.body.classList.remove('modal-open');
    document.documentElement.style.overflow = 'auto'; // html
    document.body.style.paddingRight = '';
    enableScroll()

    const modalEl = document.getElementById('maintenanceModal')
    // console.log("testests", modalEl);
    if (modalEl && modalEl.classList.contains('show')) {
        modalEl.classList.remove('show')
        modalEl.style.display = '';
        modalEl.setAttribute('aria-hidden', 'true');
        modalEl.removeAttribute('aria-modal');
        modalEl.removeAttribute('role');
    }

    let tempUser = localStorage.getItem("user") ?? null;
    let isSilentLogin = localStorage.getItem("isSilentLogin", false) ?? false;
    let isProtectionPlans = localStorage.getItem("isProtectionPlans", false) ?? false;


    // console.log("isSilentLogin", isSilentLogin);

    if (isSilentLogin == 'true') {
        if ((to.meta.layout == "auth" || to.meta.allowSilentLogin) && tempUser) {
            return next();
        } else if (isProtectionPlans && tempUser) {
            return next();
        } else {

            if(to.path == "/price-list" ){
                return next();
            }
            else{
            setTimeout(() => {
                localStorage.removeItem('user')
                localStorage.removeItem('isSilentLogin')
                localStorage.removeItem('isProtectionPlans')
                localStorage.removeItem('is_from_mobile')
                sessionStorage.removeItem('dashboard_selected_date') // dashboard opens on today after the next login

                return next({
                    path: '/login'
                });
            }, 300);
         }
        }
    } else if ((to.path == "/login" || to.path == "/register" || to.path == "/verification") && tempUser) {
        return next({ path: "/dashboard" });
    } 
    else if (to.meta.requiresAuth) {
        if (tempUser != null) {
            // User is authenticated, proceed to the route
            return next();
            
        } else {
            // User is not authenticated, redirect to login
            if(to.path == "/price-list" ){
                return next();
            }
            else{
                setTimeout(() => {
                    localStorage.removeItem('user')
                    localStorage.removeItem('isSilentLogin')
                    localStorage.removeItem('isProtectionPlans')
                    localStorage.removeItem('is_from_mobile')
                    sessionStorage.removeItem('dashboard_selected_date') // dashboard opens on today after the next login
    
                    return next({
                        path: '/login'
                    });
                }, 300);
            }
    
        }
    } else {
        return next();
    }
});

export default router;
